import { observer } from "mobx-react-lite";
import { ContextProps } from "@menu/core/types";
import { AnalyticsType, getAnalyticTags } from "@menu/core/lib";
import { rootElementId } from "@menu/core/constants";

const ProfileIcon = observer((props: ContextProps) => {
    const { context } = props;
    const { config, isLoggedIn } = context;

    if (config.hideProfile) {
        return null;
    }

    const eventName = "click";
    const arrowCssName = "icon-arrow-down_4px";
    const openCssName = "open";
    const profileIcon = context.isLoggedIn ? "icon-login" : "icon-profile";

    if (!isLoggedIn) {
        const url = context.authService.getSignInUrl();

        const name = context.isMobile
            ? "profile_click"
            : "login_icon"; //why the difference?

        const analytics = getAnalyticTags({
            component_name: name,
            nav_item: AnalyticsType.topLevel,
            nav_text: "sign_in",
            target_page_url: url
        })

        if (config.hideProfile) {
            return null;
        }

        return (<i
            className={profileIcon}
            {...analytics}
            onClick={() => context.authService.signIn()} />);
    }

    const getMenuElement = (openState = false) => {
        const selector = `#${rootElementId} > .profile-menu${openState ? ".open" : ""}`

        return document.querySelector(selector);
    }

    const listener = (e: any) => {
        const menu = getMenuElement(true);

        if (!menu) {
            return;
        }

        const isChild = menu.contains(e?.target);

        if (isChild) {
            return;
        }

        menu.classList.remove(openCssName);

        document.body.removeEventListener(eventName, listener);
    }

    const removeEventListener = () => document.body.removeEventListener(eventName, listener);

    const addEventListener = () => document.body.addEventListener(eventName, listener);

    const toggleIsOpen = (e: any) => {
        e.preventDefault();
        e.stopPropagation();

        const element = getMenuElement();

        const isOpen = element ? element.className.includes(openCssName) : context.displayProfileMenu;

        const newValue = !isOpen;

        element?.classList.toggle(openCssName, newValue);
        context.updateDisplayProfileMenu(newValue);

        if (newValue) {
            addEventListener();
        } else {
            removeEventListener();
        }
    }

    return (<span className="profile-container" onClick={toggleIsOpen}>
        <i className={profileIcon} />

        <i className={arrowCssName} />
    </span>);
});

export default ProfileIcon;